export enum EScrollStatusTypes {
  NA = 'N/A',
  NOT_YET_INITIATED = 'NOT YET INITIATED',
  INITIATED = 'INITIATED',
  APPROVED = 'APPROVED'
}
